import React, { memo, useMemo } from "react";

import { getBoldTitle } from "@cart-ui/helpers/BillDetails";

import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

import { GenericIcon } from "@swiggy-private/dls-web-icons/dist/GenericIconWeb";
import { default as TickIcon } from "@swiggy-private/dls-web-icons/dist/web/generic/tick/12";

import { Benefit as IBenefit } from "@swiggy-private/cart-types";
import { OFFER_BUNDLE } from "@swiggy-private/cart-test-ids";

import styles from "../styles/OfferPackNudgeWidget.scss";

const Benefit = ({ title }: IBenefit) => {
    const benefitTitle = useMemo(() => getBoldTitle(title), [title]);

    return (
        <div className={styles.benefit} data-testid={OFFER_BUNDLE.BENEFIT_ITEM}>
            <GenericIcon Icon={TickIcon} strokeColor="text_Med_Emphasis" className={styles.tickIcon} />
            <Text
                variant="V2.body2.neutral.medium"
                color="text_Med_Emphasis"
                dangerouslySetInnerHTML={{ __html: benefitTitle }}
            />
        </div>
    );
};

export default memo(Benefit);
